import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CloseIcon, InfoIcon, SuccessIcon, WarningIcon } from '../icons';
export var Toast = function (_a) {
    var message = _a.message, description = _a.description, status = _a.status, toastId = _a.id, removeToast = _a.removeToast;
    var toastStyles = {
        success: 'bg-vjwSuccess text-white',
        error: 'bg-vjwDanger text-white',
        info: 'bg-vjwPrimary text-white',
    };
    var icons = {
        success: _jsx(SuccessIcon, { className: 'mr-2 size-5' }),
        error: _jsx(WarningIcon, { className: 'mr-2 size-5' }),
        info: _jsx(InfoIcon, { className: 'mr-2 size-5' }),
    };
    return (_jsxs("div", { className: "".concat(toastStyles[status], " mb-2 flex w-64 justify-between items-start rounded p-2 text-sm font-semibold"), children: [_jsxs("div", { className: 'flex gap-2 items-center', children: [!!icons[status] && icons[status], _jsxs("div", { className: 'flex-1 font-normal', children: [_jsx("div", { children: message }), description && _jsx("div", { className: 'text-xs font-normal', children: description })] })] }), _jsx("button", { type: 'button', onClick: function () { return removeToast(toastId); }, "aria-label": 'Close', children: _jsx(CloseIcon, { size: 'md' }) })] }));
};
